import { Item, JournalCodeMapping, JournalCodesMapping, PointDeSuspens } from '../../types';

/**
 * @french
 * État initial du slice des uploadFec.
 */
export const PointsSuspensInitialState = {
  loading: false, // Indique si un upload est en cours.
  enabled:
    typeof window !== 'undefined' &&
    [
      '/cabinet/dossier-point-suspens',
      '/cabinet/questionnaire',
      '/cabinet/points-suspension',
    ].includes(window.location.pathname),
  journalCodeMappingRequests: [] as JournalCodeMapping[], // Liste des demandes de mappage des codes journaux.
  journalCodesMapping: null as JournalCodesMapping | null,
  error: null as Error | null, // Erreur survenue lors de l'upload ou null si aucune.
  fileId: '', // Identifiant unique du fichier importé.
  dateFec: undefined as Date | undefined,
  sirenFec: '',
  selectedIds: [] as string[],
  unmappedAccounts: [] as PointDeSuspens[],
  selectedItem: null as Item | null,
  fileName: undefined as string | undefined,
  fetchNew: false,
  isGenerationPopupOpen: false,
};

/**
 * @french
 * Type dérivé de l’état initial.
 */
export type PointsSuspensState = typeof PointsSuspensInitialState;
